import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const salesDataSourceDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$sourceId`,
    component: lazyRouteComponent(() => import('./SourceDetails'))
  })
